
import { createSlice } from "@reduxjs/toolkit";
import { client } from "..";
import { UPDATE_EMP_LEAVE_SETTINGS } from "../Leaves/Leaves";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { setFilteredLeaveData } from "./employeeslice";
import { CREATE_LEAVE_REQUEST, GET_EMPLOYEE_LEAVE_DETAILS, GET_LEAVES_DATA, GET_LEAVE_REQUESTS, UPDATE_LEAVES,UPDATE_LEAVE_SETTINGS, UPDATE_LEAVE_STATUS } from "../Leaves/Leaves";
import { setLoader } from "./loaderSlice";


export const updateleavesThunk = createAsyncThunk(
  'leavesettings/updateLeaves',async (updateleavedata, { dispatch,rejectWithValue }) => {
    try {
      const {data} = await client.mutate({
        mutation: UPDATE_LEAVES,
        variables: updateleavedata,
        fetchPolicy: 'no-cache',
      });

      const result = data?.createLeaves;

      if (!result || result.status !== 200) {
        return rejectWithValue(result?.message || 'Failed to update leaves.');
      }
      return result;
    } catch (error) {
      console.error('Error in updateleavesThunk:', error);
      return rejectWithValue(error?.message || 'Failed to update leaves');
    }
  }

)

export const getleavesThunk = createAsyncThunk(
  'leavesettings/getLeaves',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await client.query({
        query: GET_LEAVES_DATA,
        fetchPolicy: 'no-cache',
      });

      return data?.GetAllLeaves?.response || [];
    } catch (error) {
      console.error('Error in getleavesThunk:', error);
      return rejectWithValue(error?.message || 'Failed to fetch leaves');
    }
  }
);

export const updateleavesettingThunk = createAsyncThunk(
  'leavesettings/updateLeaveSettings',
  async (updateleavesettingdata, { rejectWithValue }) => {
    try {
      const { data } = await client.mutate({
        mutation: UPDATE_LEAVE_SETTINGS,
        variables: updateleavesettingdata,
        fetchPolicy: 'no-cache',
      });

      const result = data?.updateLeaveSettings;

      if (!result || result.status !== 200) {
        return rejectWithValue(result?.message || 'Failed to update leave settings.');
      }

      return {
        message: result.message,
        status: result.status,
        response: result.response,
      };
    } catch (error) {
      console.error('Error updating leave settings:', error);
      return rejectWithValue(error?.message || 'Failed to update leave settings.');
    }
  }
);

export const createLeaveRequestThunk = createAsyncThunk(
  'leave/createLeaveRequest',
  async (leaveData, { rejectWithValue }) => {
    try {
      const { data } = await client.mutate({
        mutation: CREATE_LEAVE_REQUEST,
        variables: leaveData,
        fetchPolicy: 'no-cache',
      });

      const result = data?.createLeaveRequest;

      if (!result) {
        return rejectWithValue('Leave request creation failed.');
      }

      return result; // this contains all leave details and history
    } catch (error) {
      console.error('Error creating leave request:', error);
      return rejectWithValue(error?.message || 'Failed to create leave request.');
    }
  }
);

export const updateLeaveStatusThunk = createAsyncThunk(
  'leaves/updateLeaveStatus',
  async (leaveUpdates, { rejectWithValue }) => {
    try {
      const { data } = await client.mutate({
        mutation: UPDATE_LEAVE_STATUS,
        variables: { leaveUpdates }, // Must be an array of LeaveUpdateInput
        fetchPolicy: 'no-cache',
      });

      const result = data?.updateLeaveStatus;

      if (!result) {
        return rejectWithValue('Failed to update leave status.');
      }

      return result; // array of updated leave objects
    } catch (error) {
      console.error('Error updating leave status:', error);
      return rejectWithValue(error?.message || 'Failed to update leave status.');
    }
  }
);

export const getLeaveRequestsThunk = createAsyncThunk(
  'leave/getLeaveRequests',
  async (filters, { dispatch,rejectWithValue }) => {
    try {
      dispatch(setLoader(true)); // Assuming you have a setLoader action to show loading state
      const { data } = await client.query({
        query: GET_LEAVE_REQUESTS,
        variables: filters, // Optional: employeeId, leaveType, leaveStatus, fromDate, toDate
        fetchPolicy: 'no-cache',
      });

      const result = data?.getLeaveRequests;

      if (!result) {
        return rejectWithValue('Failed to fetch leave requests.');
      }

      return result; // Array of leave requests
    } catch (error) {
      console.error('Error fetching leave requests:', error);
      return rejectWithValue(error?.message || 'Failed to fetch leave requests.');
    }
    finally{
      dispatch(setLoader(false)); // Hide loading state after fetching
    }
  }
);


export const getEmployeeLeaveDetailsThunk = createAsyncThunk(
  'leave/getEmployeeLeaveDetails',
  async (employeeId, { rejectWithValue }) => {
    try {
      const { data } = await client.query({
        query: GET_EMPLOYEE_LEAVE_DETAILS,
        variables: { employeeId },
        fetchPolicy: 'no-cache',
      });

      const result = data?.CalculateLeaveDaysResolver;

      if (!result) {
        return rejectWithValue('Failed to fetch employee leave details.');
      }

      return result;
    } catch (error) {
      console.error('Error fetching leave details:', error);
      return rejectWithValue(error?.message || 'Failed to fetch employee leave details.');
    }
  }
);

const initialState = {
  leaves: [],
};

export const updateEmpLeaveSettingsThunk = createAsyncThunk(
  "leaves/updateEmpLeaveSettings",
  async ({ year, department, variables }, { dispatch, rejectWithValue }) => {
   
    try {
      const { data } = await client.mutate({
        mutation: UPDATE_EMP_LEAVE_SETTINGS,
        variables: variables,
      });
 
      const filteredLeaveData =
        data?.updateEmpLeaveSettings?.[0]?.response?.[0]?.leavesSettings.find(
          (leave) => leave.year === year && leave.department === department
        );
 
      if (filteredLeaveData) {
        dispatch(setFilteredLeaveData(filteredLeaveData));
 
      }
 
      return filteredLeaveData;
    } catch (error) {
   
      return rejectWithValue(error);
    }
  }
); 
 
const leavesSlice = createSlice({
  name: "leaves",
  initialState,
  reducers: {
    addLeave: (state, action) => {
      state.leaves.push(action.payload);
    },
    removeLeave: (state, action) => {
      state.leaves = state.leaves.filter(leave => leave._id !== action.payload);
    },
    updateLeave: (state, action) => {
      const index = state.leaves.findIndex(leave => leave._id === action.payload._id);
      if (index !== -1) {
        state.leaves[index] = action.payload;
      }
    },
    setAllLeaves: (state, action) => {
      state.leaves = action.payload; // Replaces all leave requests at once
    },
  },
  extraReducers: (builder)=>{
    builder
    .addCase(getleavesThunk.fulfilled, (state, action) => {
      state.leaves = action.payload;
    })
     .addCase(getLeaveRequestsThunk.fulfilled, (state, action) => {
      state.leaves = action.payload;
    })
  }
});



export const { addLeave, removeLeave, updateLeave, setAllLeaves } = leavesSlice.actions;

export default leavesSlice.reducer;
